module.exports = __webpack_public_path__ + "dfc7e756c85939280f435c09a55b51d4.svg";